import React, { useState, useEffect } from 'react'
import { graphql } from 'gatsby'
import { RxCaretDown, RxCaretUp } from 'react-icons/rx'

import * as styles from './specialties.module.scss'

const Specialties = ({ specialtiesItem }) => {
  const [openIndexes, setOpenIndexes] = useState([])
  const [isSmallScreen, setIsSmallScreen] = useState(false)

  useEffect(() => {
    const handleResize = () => {
      setIsSmallScreen(window.innerWidth <= 767)
    }

    handleResize()

    window.addEventListener('resize', handleResize)
    return () => window.removeEventListener('resize', handleResize)
  }, [])

  const toggleListItem = (index) => {
    setOpenIndexes((prevIndexes) =>
      prevIndexes.includes(index) ? prevIndexes.filter((i) => i !== index) : [...prevIndexes, index]
    )
  }

  const renderBranchItems = (branchItems, item) => {
    return branchItems.map((branchItem) => {
      const key = branchItem.replace(/_(\w)/g, (letter) => letter.toUpperCase())
      return (
        <span
          key={branchItem}
          className={`${styles.roles_icon} ${styles[branchItem]} ${item[key] ? styles.active : ''}`}
          alt={branchItem}
          title={branchItem}
        />
      )
    })
  }

  return (
    <>
      <section className={styles.specialties}>
        <div className={styles.inner}>
          <ul className={styles['specialties_List']}>
            <li className={styles['title_text_group']}>
              <div className={styles['title_text']}>
                <h3>Specialties</h3>
              </div>
              <div className={styles['branch_text']}>
                <span>Army</span>
                <span>Navy</span>
                <span>Air Force</span>
              </div>
            </li>

            {specialtiesItem.map((item, index) => (
              <li
                key={index}
                className={openIndexes.includes(index) ? styles.open : ''}
                onClick={isSmallScreen ? () => toggleListItem(index) : null}
                // role="button"
                tabIndex={0}
                onKeyDown={(event) => {
                  if (event.key === 'Enter' || event.key === ' ') {
                    toggleListItem(index)
                  }
                }}
              >
                <h5>{item.specialty}</h5>
                <div className={styles.branches}>
                  <div className={styles.icons_group}>
                    {renderBranchItems(['army', 'armyReserve', 'armyNationalGuard'], item)}
                  </div>
                  <div className={styles.icons_group}>{renderBranchItems(['navy', 'navyReserve'], item)}</div>
                  <div className={styles.icons_group}>
                    {renderBranchItems(['airforce', 'airforceReserve', 'airforceNationalGuard'], item)}
                  </div>
                </div>

                {openIndexes.includes(index) ? <RxCaretUp /> : <RxCaretDown />}
              </li>
            ))}
          </ul>
          <div className={styles['key_legend_section']}>
            <h3 className={styles['legend_text']}>Legend</h3>
            <ul className={styles.key}>
              <li>
                <span className={`${styles.icon} ${styles['army_icon_color']}`}>A</span>
                <h4>Army</h4>
              </li>
              <li>
                <span className={`${styles.icon} ${styles['army_icon_color']}`}>AR</span>
                <h4>Army Reserve</h4>
              </li>
              <li>
                <span className={`${styles.icon} ${styles['army_icon_color']}`}>AG</span>
                <h4>Army National Guard</h4>
              </li>
              <li>
                <span className={`${styles.icon} ${styles['navy_icon_color']}`}>N</span>
                <h4>Navy</h4>
              </li>
              <li>
                <span className={`${styles.icon} ${styles['navy_icon_color']}`}>NR</span>
                <h4>Navy Reserve</h4>
              </li>
              <li>
                <span className={`${styles.icon} ${styles['airforce_icon_color']}`}>AF</span>
                <h4>Air Force</h4>
              </li>
              <li>
                <span className={`${styles.icon} ${styles['airforce_icon_color']}`}>AFR</span>
                <h4>Air Force Reserve</h4>
              </li>
              <li>
                <span className={`${styles.icon} ${styles['airforce_icon_color']}`}>ANG</span>
                <h4>Air National Guard</h4>
              </li>
            </ul>
          </div>
        </div>
      </section>
    </>
  )
}

export default Specialties

export const query = graphql`
  fragment SpecialtiesListData on STRAPI__COMPONENT_SUPERCUSTOM_SPECIALTIES_LIST {
    specialtiesItem {
      airforce
      airforceNationalGuard
      airforceReserve
      army
      armyReserve
      navy
      navyReserve
      armyNationalGuard
      specialty
    }
  }
`
